import script from "./HomeContent8-contact.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeContent8-contact.vue?vue&type=script&setup=true&lang=js"

import "./HomeContent8-contact.vue?vue&type=style&index=0&id=60a74e14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60a74e14"]])

export default __exports__